export const BROWSER_FONT_SIZE = 15 // px // learn more - https://mui.com/material-ui/customization/typography/#html-font-size

export const APP_FONT_SIZE = 20 // px

export const FIELD_BORDER_RADIUS = 10 // px

export const FIELD_BORDER_WIDTH = 1 // px

export const MuiSystemProp = {
  fullSize: 1,
}
